<template>
  <ak-card-header class="flex flex--center">
    <div class="flex__item flex flex--center">
      <h4 class="color-grey">All {{ companiesBranding }}</h4>
    </div>
    <div>
      <ak-tooltip :placement="'left'" :has-arrow="false">
        <template #trigger>
          <ak-button
            size="small"
            circle
            color="transparent"
            @click="addNewCompany({ add: add })"
          >
            <i class="color-primary icon-plus" />
          </ak-button>
        </template>
        Add New
      </ak-tooltip>
      <ak-tooltip :placement="'left'" :has-arrow="false">
        <template #trigger>
          <ak-button
            size="small"
            circle
            color="transparent"
            @click="changeWidget()"
          >
            <i class="color-grey-light icon-cog" />
          </ak-button>
        </template>
        Change Widget
      </ak-tooltip>
    </div>
  </ak-card-header>
  <ak-card-body :size="'flush'" class="flex--column overflow-y h-full">
    <ak-display-table v-if="isLoading" cosy>
      <ak-display-table-row
        v-for="number in n"
        :key="number"
        class="c-skeleton-loading"
      >
        <ak-display-table-cell class="width-40">
          <div
            class="circle circle--large bg-grey-lighter c-skeleton-loading__item"
          ></div>
        </ak-display-table-cell>
        <ak-display-table-cell>
          <ak-pack>
            <ak-pack-item>
              <div class="c-faux-text width-125" />
              <div>
                <p class="c-faux-text width-100 mb-none"></p>
              </div>
            </ak-pack-item>
          </ak-pack>
        </ak-display-table-cell>
        <ak-display-table-cell class="text-right">
          <ak-pack>
            <ak-pack-item>
              <div class="c-faux-text width-50" />
              <div>
                <p class="c-faux-text width-50 mb-none"></p>
              </div>
            </ak-pack-item>
          </ak-pack>
        </ak-display-table-cell>
      </ak-display-table-row>
    </ak-display-table>
    <ak-table
      v-if="panelSize !== 'large'"
      v-model:data="companies"
      hoverable
      hide-head
      background
      spacing="tiny"
      :empty-state="emptyState"
      :class="{ 'h-full flex': !companies.length }"
    >
      <template #default="{ row }">
        <ak-table-column :width="40">
          <router-link :to="viewCompany(row._id)" @click="row.clicked = true">
            <div v-if="row.clicked" class="p-0 width-50">
              <ak-loading-spinner :size="'small'" />
            </div>
            <div v-if="!row.clicked" class="p-small width-50">
              <img
                src="https://res.cloudinary.com/big-top/image/upload/q_auto,f_auto/v1462528865/system-v2/avatars/default-avatar-agency.png"
                class="avatar avatar--small inline"
              />
            </div>
          </router-link>
        </ak-table-column>
        <ak-table-column>
          <router-link :to="viewCompany(row._id)" @click="row.clicked = true">
            <div class="flex flex--column">
              {{ row.name }}
              <br />
              <ul class="list-inline list-inline--delimited text-small">
                <li v-for="domain in row.domains" :key="domain">
                  {{ domain.host }}
                </li>
              </ul>
            </div>
          </router-link>
        </ak-table-column>
        <ak-table-column :width="80">
          <router-link :to="viewCompany(row._id)" @click="row.clicked = true">
            <p class="m-0">{{ row.status }}</p>
          </router-link>
        </ak-table-column>
      </template>
      <template #empty>
        <div></div>
      </template>
    </ak-table>

    <ak-table
      v-if="panelSize === 'large'"
      v-model:data="companies"
      hoverable
      background
      spacing="tiny"
      :empty-state="emptyState"
      :class="{ 'h-full flex': !companies.length }"
    >
      <template #default="{ row }">
        <ak-table-column :width="40" label=" ">
          <router-link :to="viewCompany(row._id)" @click="row.clicked = true">
            <div v-if="row.clicked" class="p-0 width-50">
              <ak-loading-spinner :size="'small'" />
            </div>
            <div v-if="!row.clicked" class="p-small width-50">
              <img
                src="https://res.cloudinary.com/big-top/image/upload/q_auto,f_auto/v1462528865/system-v2/avatars/default-avatar-agency.png"
                class="avatar avatar--small inline"
              />
            </div>
          </router-link>
        </ak-table-column>
        <ak-table-column label="Name">
          <router-link :to="viewCompany(row._id)" @click="row.clicked = true">
            <div class="flex flex--column">
              {{ row.name }}
              <br />
              <ul class="list-inline list-inline--delimited text-small">
                <li v-for="domain in row.domains" :key="domain">
                  {{ domain.host }}
                </li>
              </ul>
            </div>
          </router-link>
        </ak-table-column>
        <ak-table-column label="No. Employees">
          <router-link :to="viewCompany(row._id)" @click="row.clicked = true">
            <p class="m-0 text-monospace">{{ row.noEmployees || '–' }}</p>
          </router-link>
        </ak-table-column>
        <ak-table-column label="Status" :width="80">
          <router-link :to="viewCompany(row._id)" @click="row.clicked = true">
            <p class="m-0">{{ row.status }}</p>
          </router-link>
        </ak-table-column>
        <ak-table-column label="Created On">
          <router-link :to="viewCompany(row._id)" @click="row.clicked = true">
            <p class="m-0">{{ formatDate(row.createdOn) }}</p>
          </router-link>
        </ak-table-column>
      </template>
    </ak-table>
  </ak-card-body>
</template>

<script>
import { accountObj, agencyObj } from '@akerolabs/akero-vue/src/store'
import { defineComponent, ref, computed, onMounted } from 'vue'
import { entityBranding } from '@akerolabs/akero-vue/src/services/entityBranding.js'
import { request } from '@akerolabs/akero-vue/src/utils/request'
import { ToastProgrammatic } from '@akerolabs/akero-vue/src'
import CardHeader from '@akerolabs/akero-vue/src/components/cards/CardHeader.vue'
import date from '@akerolabs/akero-vue/src/utils/date'

export default defineComponent({
  name: 'AkWidgetCompanies',

  components: {
    [CardHeader.name]: CardHeader,
  },

  props: {
    /**
     * @type {Function}
     * @description change widget function
     */
    changeWidget: {
      default: () => ({}),
      type: Function,
    },
    /**
     * @type {}
     * @description current widget name
     */
    currentWidget: {
      default: '',
      type: String,
    },
    /**
     * @type {Function}
     * @description Open add company modal
     */
    companyModal: {
      default: () => ({}),
      type: Function,
    },
    size: {
      default: '',
      type: String,
    },
    add: {
      default: () => ({}),
      type: Function,
    },
  },

  setup(props) {
    let n = 10
    const companies = ref([])
    const isLoading = ref(true)
    const panelSize = ref(props.size)

    const addNewCompany = (add) => {
      props.companyModal(add)
    }

    /**
     * @description User defined lead branding
     */
    const companiesBranding = computed(() => {
      return entityBranding('companies.plural', 'Companies')
    })
    const companiesBrandingSingular = computed(() => {
      return entityBranding('companies.singular', 'Company')
    })

    /**
     * @description Makes an api request to request leads for account/agency
     */
    const fetchCompanies = async () => {
      let companiesData = []
      const displayError = (ex) => {
        if (ex) console.log(ex)
        ToastProgrammatic.open({
          message: `Error failed to load requests`,
          type: 'danger',
        })
      }
      try {
        const { data } = await request.get('/companies', companiesRequest.value)
        companiesData = data.data
      } catch (ex) {
        companiesData = []
        displayError(ex)
      }
      companies.value = companiesData
      isLoading.value = false
    }

    /**
     * @description params for fetchLeads()
     */
    const companiesRequest = computed(() => {
      let params = {
        account: accountObj()._id,
        agency: agencyObj()._id,
        deleted: JSON.stringify({ $ne: true }),
      }
      return {
        params,
      }
    })

    /**
     *  @description Go to Company
     */
    const viewCompany = (companyId) => {
      return {
        name: 'companies.manager.edit',
        params: { id: companyId },
      }
    }

    /**
     *
     * @param {*} dateString
     * @description format createdOn into DD/MM/YYYY
     */
    const formatDate = (dateString) => {
      return date(dateString).format('DD/MM/YY')
    }

    /**
     *
     * @description Create empty state for table
     */
    const emptyState = {
      title: entityBranding('companies.plural', 'Companies'),
      icon: 'briefcase',
      text:
        'There are currently no ' +
        entityBranding('companies.plural', 'Companies'),
      button: 'Add ' + entityBranding('companies.singular', 'Company'),
      click: () => props.companyModal({ add: props.add }),
    }

    onMounted(async () => {
      await fetchCompanies()
    })

    return {
      companies,
      addNewCompany,
      companiesBranding,
      companiesBrandingSingular,
      isLoading,
      n,
      panelSize,
      formatDate,
      viewCompany,
      emptyState,
    }
  },
})
</script>
